module.exports = {
  common: {
    sellOut: "Out of stock",
    all: "All",
    searchPlaceholder: "Searching in Wellcome",
    recentlySearched: "Search history",
    hotKeywords: "Hot Keywords",
    clearAll: "Clear All",
    language: "language",
    register: "Sign up",
    login: "Log in",
    home: "Home",
    searchResult: "Search Result",
    wellcome: "Wellcome",
    aboutWellcome: "About Wellcome",
    filter: " filter",
    sortBy: "Sort By",
    recommended: "Recommended",
    topSales: "Top Sales",
    price: "Price",
    brand: "Brand",
    showResult: "Show result",
    show: "Show",
    result: "result",
    results: "results",
    lowestFirst: "Lowest First",
    highestFirst: "Highest First",
    outOfStock: "Out of stock",
    addToCart: "Add to Cart",
    previous: "Previous",
    next: "Next",
    goToPage: "Go to Page",
    go: "Go",
    soldOut: "Sold Out",
    showMore: "Show More",
    showLess: "Show Less",
    allCategories: "All Categories",
    account: "My Account",
    addresses: "Addresses",
    myCards: "My Cards",
    myCoupons: "My Coupons",
    myOrders: "My Orders",
    accountSetting: "Account Setting",
    logout: "Logout",
    point: "Points",
    worth: "Worth",
    confirm: "Confirm",
    cancle: "Cancle",
    logOutTips: "Logout Reminder",
    logOutMsg: "Are you sure you want to logout? ",
    logoutSuccess: "Logout successfully",
    freeDeliveryAbove: "Get free delivery above <span class='free'>{amount}</span>",
    freeDeliveryMore: "<span class='free'>{amount}</span> more to get free delivery",
    freeDeliveryGet: "Great! You get free delivery!",
    viewAll: "View All",
    findSimilar: "Find Similar",
    similarProducts: "Similar Products",
    loginAndregister: "Sign up | Log in",
    signUpSuccess: "Sign up successfully",
    loginInSuccess: "Log in successfully",
    selectDeliveryAddress: "select Delivery Address",
    orderList: "My Orders",
    collectOrderNotice: "Add more item(s) below to cart and enjoy the offer",
    orderDetails: "Order Details",
    searchResults: "{searchResult} results",
    multipleOffers: "Multiple offers",
    loginExpired: "Login is expired, please login again if you want to continue your operation",
    checkYourAddress: "Check your address before shopping",
    checkYourAddressTips:
      " Your delivery address will affect product availability. To ensure a smooth checkout process, please check that this is the address you're shopping for. Click address above to change.",
    ok: "ok",
    deliverTo: "Deliver to",
    noAdress: "No saved address found",
    addAddress: "Add address",
    addDeliveryAddress: "Add delivery address",
    default: "Default",
    similarLikeTitle: "Similar products you might like:",
    categories: "Categories",
    noAddressPopTitle: "Where should we deliver to?",
    noAddressPopContent: "Please provide your delivery address so we can offer you the best shopping experience",
    backToBrowse: "Back to browse",
    addNewAdd: "Add Address",
    unavaliableDeliveryAddressTips:
      "Sorry,we are currently unavaliable to provide our services to your delivery address,",
    changeDeliveryAddressTips: "please try to change your delivery address or wait for our further update.",
    thankYouTips: "Thank you for your support!",
    yes: "YES",
    no: "NO",
    logoutfailed: "Logout failed",
    customer: "Customer Care",
    followUs: "Follow us on",
    wellCenter: "Wellcome Shop help center",
    storeLocator: "Store Locator",
    ourStory: "Our Story",
    corporateResponsibility: "Corporate responsibility",
    corporatePromotions: "Corporate promotions",
    contactUs: "Contact us",
    careers: "Careers",
    termsAndConditions: "Terms and conditions",
    restrictedFoodPermits: "Restricted Food Permits",
    feedback: "Give Feedback",
    shareWithCopyText: "Copied to clipboard,you're ready to share this product with friends.",
    shareWithFriends: "Share with friends"
  },
  category: {
    result: "results",
    category: "Category",
    name: "Categories",
    noResult: "We cannot find any items match your filter criteria, please modify and try again.",
    search: "Search ",
    noResults: "No Results",
    all: "All"
  },
  search: {
    noResultTip:
      "Sorry, we can't find <span class='highlight'>\"{keyword}\"</span> product(s). We recommended relevant items for you:",
    resultTip: "{count} items found for <span class='highlight'>\"{keyword}\"</span>"
  },
  footer: {
    download: "Great deals at your fingertips. Download now!",
    aboutWellcome: "About Wellcome",
    aboutMarketplace: "About Market Place",
    faq: "FAQs",
    contact: "Contact Us",
    email: "Email",
    payment: "Payment Methods",
    terms: "Terms & Conditions",
    privacy: "Privacy Policy",
    dfi: "DFI Retail Group",
    storeLocator: "Store Locator",
    ourStory: "Our Story",
    corporateResponsibility: "Corporate Responsibility",
    corporatePromotions: "Corporate Promotions",
    careers: "Careers",
    restrictedFoodPermits: "Restricted Food Permits",
    officeHours: "Office Hours",
    followUs: "Follow Wellcome on",
    officeHoursValue: "Monday - Sunday 9:00a.m. - 10:00p.m.",
    wellcomeWhatsAppTermsAndConditions: "Wellcome WhatsApp Terms and Conditions"
  },
  cms: {
    addToCart: "Add to Cart",
    findSimilar: "Find Similar",
    viewAll: "View All"
  },
  productDetails: {
    selectOption: "Select Option",
    comingSoon: "Coming soon",
    productDetails: "Product Details",
    youMightAlsoLike: "You might also like",
    freshnessTitle: "Freshness Information",
    freshnessInfo: "Wellcome promises this item will stay fresh for {num} days, including the day of delivery.",
    size: "Size",
    storage: "Storage",
    freshness: "Freshness",
    country: "Place of Origin",
    offers: "Offers",
    description: "Description",
    redemption: "Redemption",
    gift: "Gift"
  },
  paymentSuccessful: {
    tips: "Payment status is delayed by about 3-5 minutes. If you have any questions, please contact customer service.",
    paymentSuccessful: "Payment Succesful!",
    expectedDeliveryDateAndTime: "Expected Delivery Date and Time:",
    expectedPickupDateAndTime: "Expected Pick up Date and Time:",
    continueShopping: "Continue Shopping",
    viewOrder: "View Order",
    pickUpDate: "Pick up in {date} days"
  },
  pendingPayment: {
    pendingPayment: "Pending Payment",
    tips: "Payment will be processed in Hong Kong Dollars (HK$)",
    with: " with enJoy Card",
    saved: "Saved",
    payFail: "Payment Error Detected"
  },
  order: {
    hideDetails: "Hide Details",
    showDetails: "Show Details",
    lastThreeMonths: "Orders of last 3 months",
    threeMonthsAgo: "Orders of 3 months ago",
    ordersFromWebsite: "Orders from Website",
    pleaseSelect: "Please select",
    goToAppTips: "Please go to our Wellcome app and check more details",
    total: "Total",
    pieces: "pieces",
    orderPlaced: "Order placed:",
    parentOrderNo: "Parent Order No:",
    orderNo: "Order No:",
    noAppOrder: " No order record is located",
    noWebOrder: " No order record is located",
    startShopping: "Start Shopping",
    my: "My",
    order: "Online Shop Order",
    banner:
      "All orders are synced from the Wellcome app. Some orders might be split, but we will deliver them together for each purchase.",
    syncedOrder: "Current order is synced from Wellcome app.",
    gift: "Gift",
    redeemed: "Redeemed"
  },
  orderDetails: {
    orderNo: "Order number:",
    checkSignature: "Check signature",
    eReceipt: "E-receipt",
    deleteOrder: "Delete Order",
    deleteOrderTips: "Are you sure you want to delete the order?",
    cancel: "Cancel",
    buyAgain: "Buy Again",
    stayHere: "Stay here",
    goToCart: "Go to cart",
    copySuccess: "Copy successfully",
    deleteOrderSuccess: "Order is deleted",
    cancelOrderSuccess: "Order is cancelled",
    reason: "Please select a Reason",
    totalItems: "Total {totalCount} Item(s)",
    freeGifts: "Free gifts",
    free: "Free",
    checkout: "Checkout",
    orderSummary: "Order summary",
    saved: "Saved",
    total: "Total",
    relatedOrderNo: "Related Order No:",
    cancelReason: "Cancel Reason",
    reasonPlaceholder: "Please select a reason",
    confirm: "Confirm",
    cancelOrder: "Cancel Order",
    cancelAll: "Cancel All",
    quantity: "QTY",
    productdisabledTitle: "View item details with Wellcome app",
    outOfStock: "Out of stock",
    ordersFromDifferentStores:
      "This order contains multiple orders from different stores, please click 'Confirm' to cancel the entire order.",
    confirmO: "Confirm",
    pendingPaymentTips:
      "This order contains multiple orders from different stores, please click continue to proceed the checkout.",
    confirmP: "Continue",
    contactOurDeliveryMan: "Contact our delivery staff"
  },
  dshop: {
    activityNotStarted: "This promotion event has not started yet, please come again later({code})",
    activityOver: "This promotion event has ended, thank you for your support({code})",
    activityRegionNotMatch:
      "Sorry, this promotion event is not supporting your delivery address, thank you for your support({code})",
    activitySorryWrong: "Sorry, the network is unstable, please retry({code})",
    retry: "Retry",
    goToHomepage: "Go to homepage",
    allCategories: "All {num} categories"
  },
  cart: {
    my: "My",
    myCart: "My Cart",
    selectAll: "Select All",
    remove: "Remove",
    addMore: "Add more",
    deliverTo: "Deliver to",
    change: "Change",
    edit: "Edit",
    coupons: "Coupons",
    applied: "applied",
    available: "available",
    total: "Total",
    totleSaved: "Saved",
    saved: "Saved",
    checkout: "Check out",
    removeTitle: "Remove from the cart",
    removeMessage: "Are you sure you want to remove these item(s) ?",
    cancel: "Cancel",
    addressChangedTips: "Your basket has been updated to reflect available items",
    stockTips: "Only {stock} unit(s) left",
    maximumStockTips: "The quantity of selected item has reached the maximum stock",
    rangeNotNearestTitle:
      "The following items have been added for a different delivery region or delivery method. Please change your address or delivery mode to recover them",
    rangeStandardDeliveryTitle:
      "The following items cannot be delivered to you, please enjoy the full shopping experience in our Wellcome app",
    unRangeStoreGroupTitle:
      'The following items cannot be delivered to you with "Express" or "Pre-Order" store in the website yet, please enjoy the full shopping experience in our Wellcome app',
    deliveryAndPackagingFee: "Including delivery fee ${deliveryFee} + packaging handling fee ${packagingFee}",
    onlyDeliveryFee: "Including delivery fee ${deliveryFee}",
    onlyPackagingFee: "Including packaging handling fee ${packagingFee}",
    handlingAndPackagingFee:
      "Including Click & Collect Handling Fee ${handlingFee} + packaging handling fee ${packagingFee}",
    onlyHandlingFee: "Including Click & Collect Handling Fee ${handlingFee}",
    saveMoreOffersTitle: "Save more with our offers",
    viewMore: "View more",
    viewLess: "View less",
    emptyText: "Your Cart is Empty",
    continueShopping: "Continue Shopping",
    freeGifts: "Free gifts",
    soldout: "Sold out",
    free: "Free",
    unavailableWaresTitle:
      "Your basket may have been changed due to a change in delivery region or delivery method. View the removed items below",
    findSimilar: "Find similar",
    editRecipient: "Edit Recipient",
    mandatoryFields: "* mandatory field(s)",
    recipientName: "Recipient Name*",
    recipientMobileNumber: "Recipient Mobile Number*",
    recipientWarningTextWith11Digits: "Please enter 11-digits of phone number beginning with 1",
    recipientWarningTextWith8Digits: "Please enter 8-digits of phone number",
    save: "Save",
    myAddresses: "My Addresses",
    select: "Select",
    giftSelectMsg: "Select {maxGiftQty} free gift(s)",
    changedGiftOrTradeMsg: "Your Gift(s)/Redeem Offer Updated",
    changedGiftOrTradeMinorMsg: "Your gift/redemption items have been updated due to changes in purchase quantity.",
    redeemFreeMsg: "Redeem selected items for Free",
    redeemVerticalReductionMsg: "Redeem selected items and Save ${value}",
    redeemDiscountMsg: "Redeem selected items and Get {value}% off",
    redeemSpecialOfferMsg: "Redeem selected items for ${value}",
    slaveStoreMsg: "Seamlessly check out items from other stores synced with your Wellcome app on the Wellcome website",
    slaveStoreTip: "View item details with Wellcome app",
    RedeemNow: "Redeem now",
    GoBack: "Go Back",
    pickUpAt: "Pick up at:",
    deliveryOnlyDesc: "{count} items are available for home delivery only",
    seeItems: "See items",
    deliveryOnlyTitle: "The following items are only available for home delivery",
    reminder: "Reminder",
    giftMessage:
      "You have forgot or haven't added enough free gift item(s) to your cart, do you still want to continue checkout?",
    no: "No",
    yesContinue: "Yes, Continue",
    giftNotEnough: "Sorry, inventory is not enough",
    allGiftOutOfStock: "Sorry, all free gift(s) are out of stock",
    pleaseEnterPickupName: "Please input the pickup person's name"
  },
  coupon: {
    myCoupons: "My Coupons",
    emptyText: "You don't have any coupons yet",
    usageRules: "Usage rules",
    valid: "Valid",
    invalid: "Invalid",
    reedem: "Redeem",
    reedemMessage: "Your coupon has been successfully redeemed!",
    daysLeft: "{count} day(s) left",
    effectivePeriod: "Effective Period",
    applicableFor: "Applicable for",
    coupons: "Coupon(s)",
    apply: "Apply",
    applySuccessMessage: "Your coupon has been successfully applied!",
    applyInapplicableMessage:
      "Sorry, this coupon is not applicable to the current order.Please double check its usage conditions.",
    chosenSavedText: "You have chosen {length} coupon(s), and Saved",
    applicable: "Applicable",
    inapplicable: "Inapplicable",
    enterPlaceholder: "Enter your coupon code here",
    EGiftVoucher: "Online Shop Voucher",
    ECoupon: "E-Coupon",
    combinedText: "Can be combined with other coupon"
  },
  checkout: {
    mark1: "Please call me before delivery",
    mark2: "Please leave the goods at door",
    markAny: "Please fill other instructions here if any",
    save: "save",
    headerTitle: "Secure Checkout",
    deliverTo: "Deliver to",
    edit: "Edit",
    addDeliveryIns: "Add Delivery Instruction",
    deliveryIns: "Delivery Instruction",
    deliverTime: "Deliver Time",
    pleaseSelect: "Please Select",
    noAvailable: "No available delivery slot",
    coupons: "Coupons",
    available: "available",
    applied: "applied",
    paymentMethod: "Payment Method",
    cardTips: "We current only accept credit card (Visa and MasterCard only) payments on our website.",
    cardTips2:
      "A temporary charge of HK$0.10 may appear in your transaction history to verify that your card is open and in good standing. Upon verification, the HK$0.10 will be released.",
    promotionTips:
      "Save 8% on your purchases of $100 or more (net spending) at Wellcome & Market Place with Hang Seng enJoy Card today.",
    addNewCard: "Add New Credit Card",
    orderReview: "Order Review",
    DSecureAuth: "3-D Secure Auth",
    add: "Add",
    change: "Change",
    select: "Select",
    next: "Next",
    payNow: "Pay & Verify",
    cardVeri: "Credit Card Verification",
    mandatoryFileds: "mandatory field(s)",
    cardNumber: "Visa & Master Card Number",
    amexCardNumber: "American Express Card Number",
    creditCardNumber: "Your Credit Card number",
    expiryDate: "Expiry Date (month/year)",
    mm: "MM",
    yy: "YY",
    digits: "3 or 4 digits on the back of card",
    cardholderName: "Cardholder's name",
    nameOnCard: "Your name on the card",
    saveTips: "Save credit card as default for next purchase",
    saveTips2: "I acknowledge that my card information is saved in my account for future transactions",
    showDetails: "Show Details",
    hideDetails: "Hide Details",
    total: "Total",
    total2: "Total",
    item: "Item(s)",
    orderSummary: "Order Summary",
    infoTips: "If out of stock, deliver remaining items (out-of-stock items will be auto refunded)",
    pay: "Pay",
    saved: "Saved",
    summaryTips1: 'By clicking "Pay", I agree that the',
    summaryTips2: "will govern my purchase.",
    errorTips: "error status",
    bindCardSuccess: "bind card success",
    Including: "Including ",
    deliveryFee: "delivery fee",
    packagingHandlingFee: "packaging handling fee",
    week: ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"],
    month: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July", "Aug", "Sept", "Oct", "Nov", "Dec"],
    format: "en",
    freeGifts: "Free gifts",
    free: "Free",
    note: "Note",
    backToCart: "Back to Cart",
    pendingPayment: "Pending Payment",
    notice: "Notice",
    text: "For standard products ordered, you cannot cancel such order once we have commenced/confirmed packing, picking or delivery of the products to you. For any special items ordered, no cancellation is possible after payment confirmation.",
    tipsCancel: "Under 18",
    tipsConfirm: "18 or above",
    noCardTips: "Select your payment method",
    payAnyway: "Pay Anyway",
    cardBrand: "Visa or MasterCard",
    error: {
      cardNumber: "Please use a {cardBrand} credit card, or check if the card number is correct",
      pleaseEnterAmexCardNumber: "Please input the American Express card number",
      pleaseEnterCardNumber: "Please input the Visa & Master card number",
      expiryDate: "Incorrect expiry date",
      securityCode: "CVV invalid or missing"
    },
    systemError: "You stayed on this page too long, please enter this page again.",
    homeDelivery: "Home Delivery",
    clickCollect: "Click & Collect",
    pickAt: "Pick up at:",
    noTimeTips: "Please select delivery time",
    recommended: "Recommended",
    continueWithThisSlot: "Continue with this slot",
    unableTips: "Deselecting items may change the promotions and freebies options. Delivery fee may also apply.",
    viewCart: "View in my cart",
    processCheckout: "Proceed to check out",
    unavailableItems: "Unavailable items",
    unavailableItemsWarn:
      "If you proceed with this time slot, the item mentioned below will not be included in your payment but will remain in your cart.",
    unavailableItemsText:
      "By continue with this slot you will have changes on  promotions, freebie, or redemptions item.",
    redeemed: "redeemed",
    gift: "Gift",
    full: "Full",
    deliveryFee2: "Delivery fee:"
  },
  card: {
    myCards: "My Cards",
    add: "Add New Card",
    deleteCard: "Delete Credit Card",
    confirmText: "Are you sure you want to delete this credit card from your account? ",
    cancel: "No",
    confirm: "Delete",
    message: "Successfully unbinding"
  },
  pageTitle: {
    cart: "My Cart",
    checkout: "Secure Checkout",
    cards: "My Cards",
    coupons: "My Coupons",
    order_list: "My Orders",
    order_details: "Order Details",
    cashier: "Checkout Cashier",
    payment: "Payment Successful",
    categoryName: "{name}",
    storeLocator: "Store Locator"
  },
  getTheApp: {
    title: "Wellcome mobile is better on the Wellcome app ",
    description: "For an optimized mobile experience, shop in Wellcome online shop now!",
    goTo: "Go to Wellcome",
    notNow: "Not now"
  },
  page: {
    title: "Wellcome online shop",
    description:
      "Explore a wide range of fresh produce, rice, oil, beverages, beers, wines, spirits, personal care items and groceries at the Wellcome e-Store. Enjoy great savings on case deals, 24-hour delivery and free shipping over $500! Shop now!"
  },
  error: {
    pageNotFound: "Page Not Found",
    serverError: "Server Error",
    backHome: "Go to homepage",
    notFound: "404 - PAGE NOT FOUND",
    notFoundTips: "The page you are looking for might have removed",
    internalServerError: "500 - INTERNAL SERVER ERROR",
    internalServerErrorTips: "Sorry, the server is temporarily unavailable. Please try again later."
  },
  collect: {
    bestOfferTitle: "SmartSaver",
    bestOfferText1: "Offer(s) available",
    bestOfferText2: "Add more item(s) to enjoy our offer(s)"
  },
  address: {
    addNewAddress: "Add new address",
    confirm: "Confirm",
    pleaseNoteQuantityAndPromotions:
      "Please note that the quantity and promotions may vary based on your chosen delivery method.",
    edit: "Edit",
    remove: "Remove",
    default: "Default address",
    defaultAddressTips: "This will be your default address automatically",
    mandatoryFields: "Required",
    address: "Address",
    floorAndUnit: "Floor & Unit",
    buildingAndEstate: "Building & Estate",
    addressLabel: "Address Label",
    selectDeliveryAddress: "Select delivery address",
    addAddress: "Add address",
    pleaseFillYourAddressHere: "Please fill your address here",
    EgUnit606: "E.g. Room 601",
    pleaseFill: "Optional",
    enterAddressLabel: "Enter Address Label",
    editAddress: "Edit address",
    removeThisAddress: "Remove this address?",
    actionCannotUndone: "This action cannot be undone.",
    keepAddress: "Keep address",
    addressRemoved: "Address Removed",
    home: "Home",
    work: "Work",
    other: "Other",
    makeThisMyDefaultAddress: "Make this my default address",
    noData: "no Data",
    leavePageTipsTile: "Are you sure you want to leave this page?",
    leavePageTips: "If you leave this page, any changes you have made will be lost.",
    returnToSite: "Return to site",
    continueEdit: "Continue editing",
    freeAndFastDelivery: "Free & fast delivery!",
    addressAdded: "Address has been added",
    addressUpdated: "Address has been updated",
    loadingText: "Loading",
    userName: "Name",
    phone: "Phone Number",
    pleaseEnterName: "Please enter name",
    pleaseEnterPhoneNumber: "Please enter phone number"
  },
  deliveryMethod: {
    title: "Delivery method",
    homeDelivery: "Home delivery",
    clickCollect: "Click & collect",
    clickCollectTip: "Save more delivery fee!",
    deliveryOnly: "Delivery only",
    lowerDeliveryFee: "Free click & collect service upon low min. spend!",
    nonDeliveryDesc: "on orders over HK${amount}",
    selectPickupStore: "Select store for pick-up",
    region: "Region",
    district: "District",
    storeDisabledDesc: "Storage full, please try another day.",
    clickCollectNotice: "Please note that the quantity and promotions may vary based on your chosen delivery method.",
    confirm: "Confirm",
    pleaseSelect: "Please select",
    emptyText: "No data",
    stayTunedDesc: "More stores coming soon! Stay tuned!"
  },
  storeLocator: {
    fullMapView: "Full Map View",
    showListVew: "Show List View",
    title: "Store Locator",
    region: "Region",
    district: "District",
    service: "Service",
    listView: "List View",
    mapView: "Map View",
    getDirections: "Get Directions",
    enterAddressOrBuilding: "Enter address/building",
    openingHours: "Opening Hours",
    nearestStore: "Nearest Store",
    locationError: "Google Maps could not determine your precise location.",
    locationGet: "Please enable browser location authorization",
    locationTimeout: "Timeout when getting location"
  }
}
